// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1RDnt","prices":"style_prices__ldAY4","tag":"style_tag__1KcEZ"};